import React, {useEffect, useState} from 'react'

const OfferCreateRowTotal = ({record}) => {
    const [totalPrice, setTotalPrice] = useState(0)

    useEffect(() => {
        const total = record.rowTotal || 0
        setTotalPrice(total)
    })

    return (
        <React.Fragment>
            <p style={{marginBottom: '24px'}}>{new Intl.NumberFormat().format(totalPrice)}</p>
        </React.Fragment>
    )
}
export default OfferCreateRowTotal